const PERMISSIONS = {
  // Xóa folder
  DELETE_FOLDER: "D.D.F.01",
  // Sửa tài liệu
  EDIT_DOCUMENT: "D.E.F.I.01",
  // Xem nhật ký
  VIEW_LOG: "D.V.D.H.01",
  // Upload tài liệu
  UPLOAD_DOCUMENT: "D.U.F.I.01",
  // Xóa tài liệu/Chuyển lỗi thời
  DELETE_OR_ARCHIVE_DOCUMENT: "D.D.F.I.01",
  // Thống kê tài liệu triển khai/Thống kê số lượng người đọc…
  STATISTICS_DOCUMENT_DEPLOYMENT: "D.S.D.01",
  // Triển khai tài liệu
  DEPLOY_DOCUMENT: "D.P.F.I.01",
  // Tải xuống/In tài liệu soạn thảo
  DOWNLOAD_OR_PRINT_DRAFT: "D.D.A.P.01",
  // Cài đặt cấu hình
  SETTING_CONFIG: "D.C.S.01",
  // Tạo mới tài liệu/Tạo mới folder
  CREATE_DOC_FOLDER: "D.C.F.01",
  // Gán quyền
  ASSIGN_PERMISSION: "D.G.P.01",
  // Phê duyệt
  APPROVE_DOCUMENT: "D.A.F.I.01",
};

export default PERMISSIONS;
